import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { BriefcaseIcon, UsersIcon, AwardIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function Stats() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const {
    t
  } = useLanguage();
  const stats = [{
    icon: BriefcaseIcon,
    value: '500+',
    label: t('stats.websites')
  }, {
    icon: UsersIcon,
    value: '300+',
    label: t('stats.clients')
  }, {
    icon: AwardIcon,
    value: '10+',
    label: t('stats.years')
  }];
  return <section ref={ref} className="relative w-full overflow-hidden px-4 py-24" style={{
    backgroundColor: 'var(--bg-secondary)'
  }} data-id="element-1147">
      {/* Subtle background accent */}
      <div className="absolute inset-0 overflow-hidden opacity-20" data-id="element-1148">
        <div className="absolute right-0 top-1/2 -translate-y-1/2 w-[400px] h-[400px] rounded-full blur-3xl" style={{
        background: 'radial-gradient(circle, var(--accent) 0%, transparent 70%)'
      }} data-id="element-1149" />
      </div>

      <div className="relative z-10 mx-auto max-w-5xl" data-id="element-1150">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="mb-12 text-center" data-id="element-1151">
          <h2 className="mb-4 text-3xl font-bold md:text-4xl" style={{
          color: 'var(--text-primary)'
        }} data-id="element-1152">
            {t('stats.title')}{' '}
            <span style={{
            color: 'var(--accent)'
          }} data-id="element-1153">
              {t('stats.titleHighlight')}
            </span>
          </h2>
          <p className="mx-auto max-w-2xl" style={{
          color: 'var(--text-secondary)'
        }} data-id="element-1154">
            {t('stats.subtitle')}
          </p>
        </motion.div>

        <div className="grid gap-6 sm:grid-cols-3" data-id="element-1155">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} data-id="element-1156">
              <div className="h-full rounded-2xl border p-8" style={{
            borderColor: 'var(--border)',
            backgroundColor: 'var(--bg-primary)'
          }} data-id="element-1157">
                <div className="flex flex-col items-center justify-center text-center" data-id="element-1158">
                  <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-xl" style={{
                backgroundColor: 'var(--bg-tertiary)'
              }} data-id="element-1159">
                    <stat.icon className="h-8 w-8" style={{
                  color: 'var(--accent)'
                }} data-id="element-1160" />
                  </div>
                  <p className="mb-2 text-4xl font-bold md:text-5xl" style={{
                color: 'var(--text-primary)'
              }} data-id="element-1161">
                    {stat.value}
                  </p>
                  <p className="text-center" style={{
                color: 'var(--text-secondary)'
              }} data-id="element-1162">
                    {stat.label}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}